import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorComponent } from './components/validation-error/validation-error.component';
import {
  NbAlertModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule, NbPopoverModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTagModule,
  NbTimepickerModule,
  NbToggleModule, NbTooltipModule
} from '@nebular/theme';
import { NumberLimitDirective } from 'src/app/shared/directives/number-limit.directive';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/shared/pipes/jdate.pipe';
import { TimeAgoPipe } from 'src/app/shared/pipes/time-ago.pipe';
import { DatepickerComponent } from 'src/app/shared/components/datepicker/datepicker.component';
import { FixMonthDaysPipe } from 'src/app/shared/pipes/fix-month-days.pipe';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { ImageModalComponent } from './components/image-modal/image-modal.component';
import { UserLinkComponent } from 'src/app/shared/components/user-link/user-link.component';
import { RouterModule } from '@angular/router';
import { LimitDecimalNumberDirective } from 'src/app/shared/directives/limit-decimal-number.directive';
import { RangePickerComponent } from './components/range-picker/range-picker.component';
import { UserPickerComponent } from './components/user-picker/user-picker.component';
import { SelectCurrencyComponent } from 'src/app/shared/components/select-currency/select-currency.component';
import { EnabledCurrencyPipe } from './pipes/enabled-currency.pipe';
import { LanguageSelectionComponent } from './components/language-selection/language-selection.component';
import { WithdrawStatusPipe } from '../feature/modules/withdraw/pipes/withdraw-status.pipe';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { SessionsComponent } from './components/sessions/sessions.component';
import { VideoModalComponent } from './components/video-modal/video-modal.component';
import { NoteComponent } from './components/note/note.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BankNamePipe } from './pipes/bank-name.pipe';
import { TranslateBankNamePipe } from './pipes/translate-bank-name.pipe';
import { PublicNotificationComponent } from './components/public-notification/public-notification.component';
import { DateTimepickerComponent } from './components/date-timepicker/date-timepicker.component';
import { SecureImageDirective } from './directives/img-resolver.directive';
import { SecureVideoDirective } from './directives/secure-video.directive';
import { EnumMapperPipe } from './pipes/enum-mapper.pipe';
import { TransactionPipe } from './pipes/transaction.pipe';
import { TransferTypePipe } from './pipes/transfer-type.pipe';
import { ProviderPipe } from 'src/app/shared/pipes/provider.pipe';
import { PrivateNotificationComponent } from './components/private-notification/private-notification.component';
import { BypassTrustHtmlPipe } from './pipes/bypass-trust-html.pipe';
import { CryptDepositHistoryComponent } from './components/crypt-deposit-history/crypt-deposit-history.component';
import { TableModule } from 'primeng/table';
import { ImageModalSelfieComponent } from './components/image-modal-selfie/image-modal-selfie.component';
import { MarketSelectorComponent } from './components/market-selector/market-selector.component';
import { UploadImageComponent } from './components/upload-image/upload-image.component';
import { PriceFormatDirective } from './directives/price-format.directive';
import { AppUploadVideoComponent } from './components/app-upload-video/app-upload-video.component';
import { AppUploadAudioComponent } from './components/app-upload-audio/app-upload-audio.component';

const STANDALONE_COMPONENTS = [
  DateTimepickerComponent
];

@NgModule({
  declarations: [
    NumberLimitDirective,
    DateFormatPipe,
    TimeAgoPipe,
    AppUploadAudioComponent,
    OnlyNumberDirective,
    ImageModalComponent,
    ImageModalSelfieComponent,
    UserLinkComponent,
    UserPickerComponent,
    LanguageSelectionComponent,
    WithdrawStatusPipe,
    SessionsComponent,
    VideoModalComponent,
    NoteComponent,
    BankNamePipe,
    TranslateBankNamePipe,
    PublicNotificationComponent,
    PrivateNotificationComponent,
    SecureImageDirective,
    SecureVideoDirective,
    EnumMapperPipe,
    TransactionPipe,
    TransferTypePipe,
    BypassTrustHtmlPipe,
    ProviderPipe,
    CryptDepositHistoryComponent,
    MarketSelectorComponent,
    UploadImageComponent,
    PriceFormatDirective,
    AppUploadVideoComponent
  ],
  imports: [
    ...STANDALONE_COMPONENTS,
    CommonModule,
    NbCardModule,
    NbButtonModule,
    NbCheckboxModule,
    NbFormFieldModule,
    NbIconModule,
    NbAlertModule,
    NbInputModule,
    NbSelectModule,
    NbAutocompleteModule,
    FormsModule,
    LimitDecimalNumberDirective,
    RouterModule,
    NbSpinnerModule,
    NbTagModule,
    Ng2SmartTableModule,
    NgxSkeletonLoaderModule,
    NbAutocompleteModule,
    NbToggleModule,
    NbTimepickerModule.forRoot(),
    RangePickerComponent,
    DatepickerComponent,
    FixMonthDaysPipe,
    SelectCurrencyComponent,
    EnabledCurrencyPipe,
    ValidationErrorComponent,
    TableModule,
    NbTooltipModule,
    NbPopoverModule
  ],
  exports: [
    ...STANDALONE_COMPONENTS,
    CommonModule,
    ValidationErrorComponent,
    NbCardModule,
    NbButtonModule,
    NbCheckboxModule,
    NbFormFieldModule,
    NbIconModule,
    NbAlertModule,
    NbInputModule,
    NumberLimitDirective,
    NbSelectModule,
    DateFormatPipe,
    TimeAgoPipe,
    DatepickerComponent,
    OnlyNumberDirective,
    ImageModalComponent,
    VideoModalComponent,
    NbSpinnerModule,
    UserLinkComponent,
    LimitDecimalNumberDirective,
    RangePickerComponent,
    UserPickerComponent,
    SelectCurrencyComponent,
    LanguageSelectionComponent,
    WithdrawStatusPipe,
    SessionsComponent,
    BankNamePipe,
    TranslateBankNamePipe,
    PublicNotificationComponent,
    TransferTypePipe,
    PublicNotificationComponent,
    DateTimepickerComponent,
    SecureImageDirective,
    SecureVideoDirective,
    EnumMapperPipe,
    TransactionPipe,
    BypassTrustHtmlPipe,
    ProviderPipe,
    CryptDepositHistoryComponent,
    MarketSelectorComponent,
    UploadImageComponent,
    PriceFormatDirective,
    AppUploadVideoComponent,
    AppUploadAudioComponent
  ]
})
export class SharedModule {
}
